const breakpoints = {
  xs: 320,
  s: 414,
  m: 768,
  l: 1024
}

const matchMedia = (type, size) => {
  if (!window.matchMedia) {
    return
  }

  let value = breakpoints[size]
  if (type === "max-width") {
    value--
  }
  return window.matchMedia(`(${type}: ${value}px)`).matches
}

export const isOnMobile = () => {
  return matchMedia("max-width", "m")
}

export default matchMedia
